import ApiService from '@/services/core/api.service'

const PendingRawDataService = {
  async get (query) {
    return ApiService.get(`agent/pending-raw-data?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/pending-raw-data', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/pending-raw-data/${payload.id}`, payload)
  }
}

export default PendingRawDataService
